// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"27253":"31d6cfe0","34894":"31d6cfe0"}[chunkId] + ".chunk.css";
};